package top.wcpe.allincore.ui.runtime.render.model

/**
 * 遮罩类型枚举。
 *
 * RECT/CIRCLE/WAVE/PIE 由 fragment shader SDF 判定 discard；NONE 表示无遮罩。
 * INVERT_RECT/INVERT_CIRCLE/INVERT_ROUND_RECT 为反向遮罩（spotlight 挖洞），
 * 在元素中心扣掉一个区域、保留外圈像素，用于 spotlight 教程引导等场景。
 *
 * ADR-0072 决策 1 镜像：真源为 `platform-client-api` 的
 * `top.wcpe.allincore.platform.client.api.render.command.MaskType`
 * （纯 Java 8 对外 API，按 ADR-0002 不得 KMP 化）。值名与声明序逐一照抄真源，
 * 一致性由 jvmTest 的 RenderModelConsistencyTest 守护。
 */
enum class MaskType {
    /** 无遮罩 */
    NONE,

    /** 矩形遮罩（param1=宽比例, param2=高比例, param3 保留） */
    RECT,

    /** 圆形遮罩（param1=半径比例, param2/param3 保留） */
    CIRCLE,

    /** 波浪遮罩（param1=幅度, param2=频率, param3=相位） */
    WAVE,

    /** 饼图剪裁（param1=startAngle 弧度，0=正 X 方向，顺时针递增；param2=sweepAngle 弧度；param3 保留） */
    PIE,

    /** 反向矩形挖洞（param1=洞宽相对元素宽度比例 0~1，param2=洞高相对元素高度比例 0~1，param3 保留） */
    INVERT_RECT,

    /** 反向圆形挖洞（param1=半径相对 min(halfW, halfH) 比例 0~1，param2/param3 保留） */
    INVERT_CIRCLE,

    /** 反向圆角矩形挖洞（param1=洞宽比例 0~1，param2=洞高比例 0~1，param3=圆角半径像素值） */
    INVERT_ROUND_RECT,
}
